import FareListContainer from '../../../../components/containers/FareListContainer';
import preloadCustomProps from '../../../utils/preloads/preloadFareProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fare-list--two-columns',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FareListContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
